import { render, staticRenderFns } from "./UserEditComponent.vue?vue&type=template&id=0fa1f469"
import script from "./UserEditComponent.vue?vue&type=script&lang=js"
export * from "./UserEditComponent.vue?vue&type=script&lang=js"
import style0 from "./UserEditComponent.vue?vue&type=style&index=0&id=0fa1f469&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports